import { LinkedIssue } from './linked-issue.model';
import { LinkedDocument } from './linked-document.model';
import { Guid } from '../guid';
import { LinkedCustodian } from './linked-custodian.model';

export class Fact {
	public id: string = Guid.Empty;
	public caseId: string = Guid.Empty;
	public title: string = '';
	public dateStart: string;
	public dateEnd: string;
	public contested: number = 3;
	public material: number = 0;
	public linkedDocuments: LinkedDocument[] = [];
	public linkedIssues: LinkedIssue[] = [];
	public linkedCustodians: LinkedCustodian[] = [];
}

